import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(4)">
      <path
        d="M21,5 L20.83,5 L20.83,7 L21,7 C21.5522847,7 22,7.44771525 22,8 L22,28 C22,28.5522847 21.5522847,29 21,29 L3,29 C2.44771525,29 2,28.5522847 2,28 L2,8 C2,7.44771525 2.44771525,7 3,7 L3.17,7 L3.17,5 L3,5 C1.34314575,5 -1.77635684e-15,6.34314575 -1.77635684e-15,8 L-1.77635684e-15,28 C-1.77635684e-15,29.6568542 1.34314575,31 3,31 L21,31 C22.6568542,31 24,29.6568542 24,28 L24,8 C24,6.34314575 22.6568542,5 21,5 Z"/>
      <path d="M19,3 L16,3 L16,0 L8,0 L8,3 L5,3 L5,9 L19,9 L19,3 Z M17,7 L7,7 L7,5 L10,5 L10,2 L14,2 L14,5 L17,5 L17,7 Z"/>
      <rect width="12" height="2" x="6" y="13" className="euiIcon__fillSecondary"/>
      <rect width="12" height="2" x="6" y="18" className="euiIcon__fillSecondary"/>
      <rect width="12" height="2" x="6" y="23" className="euiIcon__fillSecondary"/>
    </g>
  </svg>
);
